import request from '@/axios'
export function displayField (moduleName, customerId) {
  return request({
    url:`/users/display_field/${moduleName}/${customerId}`,
    method: 'GET'
  })
}

export function UploadImage (payload, customer_id) {
  return request({
    url:`/file/upload/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function GetLanguageList () {
  return request({
    url:'/platformLanguages/list',
    method:'GET'
  })
}
export function GetCountryList () {
  return request({
    url:'/platformCustomerCountries/list',
    method:'GET'
  })
}

//getting specific repository id for all modules


// http://localhost:8000/api/repository-detail/2
export function GetRepositoryId (customer_id, payload) {
  return request({
    url:`/repository-detail/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function platformModuleslistApi () {
  return request({
    url: '/platformModules/list',
    method: 'GET'
  })
}

export function quickbooksRedirectionUrl (customer_id) {
  return request({
    url: `/quickbooks/connect/${customer_id}`,
    method: 'GET'
  })
}

export function quickbookConnect (customer_id, payload) {
  return request({
    url:`/quickbooks/connect/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function quickbookSync (payload) {
  return request({
    url:'/manual_invoices/sync',
    method:'POST',
    data:payload
  })
}
export function quickbookActivation (payload) {
  return request({
    url:'/quickbooks/active-deactive',
    method:'POST',
    data:payload
  })
}

export function quickbooksFetch (page, customer_id) {
  return request({
    url: `/quickbooks/fetch/${customer_id}?page=${page}`,
    method: 'GET'
  })
}

export function quickbooksDisconnect (customer_id) {
  return request({
    url: `/quickbooks/disconnect/${customer_id}`,
    method: 'GET'
  })
}

export function quickbooksStatus (customer_id) {
  return request({
    url: `/quickbooks/get-status/${customer_id}`,
    method: 'GET'
  })
}

export function getPaymentGatewaySettings (customer_id) {
  return request({
    url: `operationalUser/payment/show/${customer_id}`,
    method: 'GET'
  })
}

export function createPaymentGatewaySettings (customer_id, payload) {
  return request({
    url: `operationalUser/payment/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}